
import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/b80a9343454ed0e5c51dc774e5b90fca.jpg"
          alt="Mulher líder confiante"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#8E217E]/95 via-[#7A1C6C]/90 to-[#66175A]/85"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-8 py-32">
        <div className="max-w-3xl">
          <h1 className="font-display text-7xl lg:text-8xl font-bold text-white mb-6 tracking-tight leading-tight">
            Decida liderar.
          </h1>
          <p className="text-2xl lg:text-3xl text-white/90 mb-12 leading-relaxed font-light">
            Sua carreira. Seus resultados. Seu tempo. Sua vida.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Link
              to="/inscricao"
              className="bg-gold-500 text-[#52124A] px-10 py-5 rounded-full text-lg font-bold hover:bg-gold-400 transition-all hover:scale-105 shadow-2xl text-center whitespace-nowrap"
            >
              Quero me inscrever
            </Link>
            <Link
              to="/modulos"
              className="border-2 border-white text-white px-10 py-5 rounded-full text-lg font-bold hover:bg-white hover:text-[#8E217E] transition-all hover:scale-105 text-center whitespace-nowrap"
            >
              Ver módulos
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-white to-transparent z-10"></div>
    </section>
  );
}
